import React, { Component } from 'react';
import GlobalVsMyCaseDetails from '../Surgeon/GlobalVsMyCaseDetails';
import AverageCaseTimeDetails from '../Surgeon/AverageCaseTimeDetails';
import { getImgSrc } from '../../../helpers/GlobalFunctions';
import ErrorMsgBlockComponent from '../../Error/ErrorMessageBlock';
import { operativeProcedureTypes } from '../../../helpers/constants';
import TSAArmPosition from './TSAArmPosition';
import OperativeApproachToggleComponent from './OperativeApproachToggle';
import TSAAvgPROMScores from './TSAAvgPROMScores';

export default class TSADashboardComponent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			operativeApproach: "all",
			operativeApproachPROM: "all",
			defaultScoreType: props.defaultScoreType
		};

	}

	/**
	* @description function to handle change in Operative approach
	* @memberof TSADashboardComponent
	*/
	handleOperativeApproachChange = (type, quadrant) => {
		let stateObj = {};
		switch (quadrant) {
			case 'cases':
				stateObj = { operativeApproach: type }
				break;
			case 'proms':
				stateObj = { operativeApproachPROM: type }
				break;

			default:
				break;
		}
		this.setState(stateObj);
	};

	/**
	* @description function to handle dataset for graph based on operative approach tab
	* @memberof TSADashboardComponent
	*/
	getDataset = () => {
		const { operativeApproachPROM } = this.state;
		const { totalCasesDetails } = this.props;
		if (!totalCasesDetails) {
			return null
		}
		let { myCases, globalCases, scoreType, lastCalculationTime } = totalCasesDetails;
		switch (operativeApproachPROM) {
			case 'anatomic':
				let { mycasesAnatomic, globalCasesAnatomic } = totalCasesDetails;
				return {
					myCases: mycasesAnatomic,
					globalCases: globalCasesAnatomic,
					scoreType,
					lastCalculationTime
				};
			case 'reverse':
				let { mycasesReverse, globalCasesReverse } = totalCasesDetails;
				return {
					myCases: mycasesReverse,
					globalCases: globalCasesReverse,
					scoreType,
					lastCalculationTime
				};

			case 'all':
			default:
				return {
					myCases,
					globalCases,
					scoreType,
					lastCalculationTime
				};
		}
	}

	/**
	* @description function to handle default score type for graph based on operative approach tab
	* @memberof TSADashboardComponent
	*/
	getDefaultScoreType = () => {
		const { operativeApproachPROM } = this.state;
		const { totalCasesDetails, scoreTypeParam, defaultScoreType } = this.props;
		if (!totalCasesDetails) {
			return null;
		}
		if (scoreTypeParam !== 'default') {
			return defaultScoreType;
		}
		let { scoreType, reverseScoreType, anatomicScoreType } = totalCasesDetails;
		switch (operativeApproachPROM) {
			case 'anatomic':
				return anatomicScoreType;
			case 'reverse':
				return reverseScoreType;
			case 'all':
			default:
				return scoreType;
		}
	}

	render() {
		const { totalGlobalCasesCount, averageCaseTime, averageTsaCasetime, totalTimeData, totalTimeDataTsa, timeFrameValue,
			handleOutcomeScoreValueChange, totalCasesDetails, outcomeScoreMessage, isRarView, surgeonDetails,
			outcomeLoading, avgCasetimeLoading, globalCaseLoading, outcomeError, avgCasetimeError, globalCaseError, setuptimePreference,
			implantTypeDropdown, selectedImplantType, armPositionError, armPositionLoading, armPositionData, handleImplantTypeChange } = this.props;
		const { operativeApproach, operativeApproachPROM } = this.state;
		const globalId = surgeonDetails && surgeonDetails.surgeonGlobalId ? surgeonDetails.surgeonGlobalId : 'N/A';
		const dataset = this.getDataset();
		const defaultScoreType = this.getDefaultScoreType();

		return (
			<>
				{isRarView && <>
					<div className="row">
						<div className="col-12">
							<div className="surgeon-details-card mb-3 py-3 px-3" data-testid="tsa-dashboard">
								<div className="row">
									<div className="col-lg-4">
										<div className="d-flex align-items-center justify-content-left">
											<div className="profile-surgeoncard d-flex align-items-center">
												<img src={getImgSrc('no-profile-image.png')} alt="Profile" />
											</div>
											<div className="px-3">
												<div className="surgeon-id-label">{surgeonDetails.name}</div>
												<div>Surgeon ID: {globalId}</div>
												<div>{surgeonDetails.noOfcases} Cases in RI.Insights</div>
											</div>
										</div>
									</div>
									<div className="col-md-8">
										<div className="customer-wrap">
											{surgeonDetails.customerInfo && surgeonDetails.customerInfo.length ?
												surgeonDetails.customerInfo.map((customer, i) => {
													return (
														<div className="customer-detail" key={`customer-${i}`}>
															<div className="surgeon-id-label">{customer.customerName || 'N/A'}</div><br />
															<div>Customer ID: {customer.customerId || 'N/A'}</div>
														</div>
													)
												})
												: ''}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</>}
				<div className="row">
					{/* My Cases and Global Cases */}
					<div className="col-md-6 height dashboard-left-block mb-2" >
						{globalCaseLoading ?
							<div className="loading-img loading-img-center"><img className="" src={getImgSrc('loading.gif')} alt="loading" /></div>
							: totalGlobalCasesCount ?
								<GlobalVsMyCaseDetails
									timeFrameValue={timeFrameValue}
									totalGlobalCasesCount={totalGlobalCasesCount}
									titleText="TSA Cases"
									procedureType={operativeProcedureTypes.TSA.text}
									operativeApproach={operativeApproach}
								>
									<OperativeApproachToggleComponent operativeApproach={operativeApproach} onChange={type => this.handleOperativeApproachChange(type, 'cases')} />
								</GlobalVsMyCaseDetails>
								: globalCaseError ?
									<ErrorMsgBlockComponent errorObject={globalCaseError} className="dashboard-blocks-body d-flex align-items-center justify-content-center" />
									: <ErrorMsgBlockComponent noData={true} className="dashboard-blocks-body d-flex align-items-center justify-content-center" />}
					</div>

					{/* Alignment Details */}
					<div className="col-md-6 height">
						{armPositionLoading ?
							<div className="loading-img loading-img-center"><img className="" src={getImgSrc('loading.gif')} alt="loading" /></div>
							: armPositionData ?
								<TSAArmPosition implantTypeDropdown={implantTypeDropdown} selectedImplantType={selectedImplantType} armPositionData={armPositionData} handleImplantTypeChange={handleImplantTypeChange} />
								: armPositionError ?
									<ErrorMsgBlockComponent errorObject={armPositionError} className="dashboard-blocks-body d-flex align-items-center justify-content-center" />
									: <ErrorMsgBlockComponent noData={true} className="dashboard-blocks-body d-flex align-items-center justify-content-center" />}
					</div>
				</div>
				<div className="row" data-testid="totalGlobalCasesCount">
					{/* Average Case Time */}
					<div className="col-md-6 bottom-row height dashboard-left-block ">
						{avgCasetimeLoading ?
							<div className="loading-img loading-img-center"><img className="" src={getImgSrc('loading.gif')} alt="loading" /></div>
							: averageCaseTime && totalTimeData ?
								<AverageCaseTimeDetails averageCaseTime={averageCaseTime} averageTsaCasetime={averageTsaCasetime} totalTimeData={totalTimeData} totalTimeDataTsa={totalTimeDataTsa} setuptimePreference={setuptimePreference} operativeProcedure={operativeProcedureTypes.TSA.text} />
								: avgCasetimeError ?
									<ErrorMsgBlockComponent errorObject={avgCasetimeError} className="dashboard-blocks-body d-flex align-items-center justify-content-center" />
									: <ErrorMsgBlockComponent noData={true} className="dashboard-blocks-body d-flex align-items-center justify-content-center" />}
					</div>

					{/* Outcome Scores */}
					<div className="col-md-6 bottom-row height">
						{outcomeLoading ?
							<div className="loading-img loading-img-center"><img className="" src={getImgSrc('loading.gif')} alt="loading" /></div>
							: totalCasesDetails ?
								<TSAAvgPROMScores
									titleText="Outcomes Scores"
									operativeProcedure={operativeProcedureTypes.TSA.inLowerCase}
									outcomeScoreMessage={outcomeScoreMessage}
									defaultScoreType={defaultScoreType}
									activeTab="avg"
									handleOutcomeScoreValueChange={handleOutcomeScoreValueChange}
									totalCasesDetails={totalCasesDetails}
									dataset={dataset}
								>
									<OperativeApproachToggleComponent operativeApproach={operativeApproachPROM} onChange={type => this.handleOperativeApproachChange(type, 'proms')} />
								</TSAAvgPROMScores>
								: outcomeError ?
									<ErrorMsgBlockComponent errorObject={outcomeError} className="dashboard-blocks-body d-flex align-items-center justify-content-center" />
									: <ErrorMsgBlockComponent noData={true} className="dashboard-blocks-body d-flex align-items-center justify-content-center" />}
					</div>
				</div>
			</>
		)
	}
}
